/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelFscCycle.ts                      *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/fsc-cycle";

export class AutogenModelFscCycle<RowType extends ModelRow> extends Endpoint<RowType, RowFscCycleFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowFscCycle extends ModelRow<RowFscCycleFields> {
	constructor(values?: Partial<RowFscCycleFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowFscCycleFields {
	calendar_day: number;
	code: string;
	company_id: string;
	cycle_type: string;
	descr: string;
	month_frequency: string;
	week_day: string;
}

